export default __webpack_public_path__ + "static/media/novel5.99622b06.jpg";